import { createContext } from 'react';

import type { StudioVisit, StudioVisitInput } from './studio-resume';

export interface StudioResumeState {
  visit: StudioVisit | null;
  remember: (visit: StudioVisitInput) => void;
}

export const StudioResumeContext = createContext<StudioResumeState>({
  visit: null,
  remember: () => undefined,
});
